/**
 * Google Analytics 4 (gtag.js). Solo páginas públicas (home, /terms).
 * ID: variable `VITE_GA_MEASUREMENT_ID` (p. ej. G-L6DFVFWYBE).
 */
const MEASUREMENT_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined)?.trim();

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function initGoogleAnalytics(): void {
  if (!MEASUREMENT_ID || typeof window === 'undefined') {
    return;
  }
  if (window.gtag) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID);
}

/** Eventos personalizados (p. ej. clic en badge de tienda). */
export function trackGaEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (!MEASUREMENT_ID || !window.gtag) {
    return;
  }
  window.gtag('event', eventName, params ?? {});
}
